import axios from "axios";

// Backend base URL. Leave REACT_APP_BACKEND_URL UNSET in production so the app
// calls the API same-origin (relative "/api"); an nginx reverse proxy then
// forwards "/api" to the backend. This makes the build DNS-agnostic — the same
// image works under any hostname. Set an absolute URL only for cross-origin
// setups (e.g. local `yarn start` against a separate backend on :8000).
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const TOKEN_KEY = "oim_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: API, timeout: 30000 });

// Attach the bearer token (if any) to every request.
http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // auth
  login: (body) => http.post("/auth/login", body).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  commandCenter: () => http.get("/command-center").then((r) => r.data),
  stateCurrent: () => http.get("/state/current").then((r) => r.data),
  history: (points = 144) => http.get(`/state/history?points=${points}`).then((r) => r.data.history),
  coalNir: () => http.get("/coal/nir").then((r) => r.data),
  coalTrend: (points = 144) => http.get(`/coal/trend?points=${points}`).then((r) => r.data.history),
  suppliers: () => http.get("/suppliers").then((r) => r.data.suppliers),
  supplierQuadrant: () => http.get("/suppliers/quadrant").then((r) => r.data.quadrant),
  supplier: (id) => http.get(`/suppliers/${id}`).then((r) => r.data),
  boilerTwin: () => http.get("/boiler/twin").then((r) => r.data),
  boilerSankey: () => http.get("/boiler/sankey").then((r) => r.data),
  production: () => http.get("/production").then((r) => r.data),
  predict: (body) => http.post("/predict/coal-requirement", body).then((r) => r.data),
  deviation: () => http.get("/deviation/investigation").then((r) => r.data),
  recommendations: () => http.get("/recommendations").then((r) => r.data.recommendations),
  alerts: () => http.get("/alerts").then((r) => r.data.alerts),
  aiInsight: () => http.post("/ai/insight").then((r) => r.data),
  aiChat: (body) => http.post("/ai/chat", body).then((r) => r.data),
  procurement: (body) => http.post("/phase2/procurement-advisor", body).then((r) => r.data),
  systemInfo: () => http.get("/system/info").then((r) => r.data),
  // simulation
  simStatus: () => http.get("/simulation/status").then((r) => r.data),
  anomalyTypes: () => http.get("/simulation/anomaly-types").then((r) => r.data.anomalies),
  simStart: () => http.post("/simulation/start").then((r) => r.data),
  simPause: () => http.post("/simulation/pause").then((r) => r.data),
  simResume: () => http.post("/simulation/resume").then((r) => r.data),
  simStop: () => http.post("/simulation/stop").then((r) => r.data),
  injectAnomaly: (anomaly_id) => http.post("/simulation/inject-anomaly", { anomaly_id }).then((r) => r.data),
  clearAnomalies: () => http.post("/simulation/clear-anomalies").then((r) => r.data),
  simReset: () => http.post("/simulation/reset").then((r) => r.data),
  factoryReset: () => http.post("/simulation/factory-reset").then((r) => r.data),
};
